import Util from '@/assets/libs/util'
import ptbr from '@/assets/lang/pt-br'
import en from '@/assets/lang/en'
import es from '@/assets/lang/es'

// valores possíveis são 'pt-br', 'en' ou 'es'
let currentLanguage = 'pt-br'

const resetToMainLanguage = () => {
    let mainLanguage = Util.getLocalConfigs('mainLanguage')
    let languageCodeOK = mainLanguage && mainLanguage[0] && mainLanguage[0].code

    if (languageCodeOK) {
        setCurrentLanguage(mainLanguage[0].code)
    }
}

const setCurrentLanguage = (language) => {
    currentLanguage = language
}

const getCurrentLanguage = () => currentLanguage

const langPortugueseEnabled = () => {
    let additionalLanguagePt = Util.getLocalConfigs('idiomaAdic_pt_br')
    let mainLanguage = Util.getLocalConfigs('mainLanguage')
    mainLanguage = (mainLanguage && mainLanguage[0] && mainLanguage[0].code === 'pt-br') || false
    let hasIdiomaAdic = hasAnyIdiomaAdic()
    return (additionalLanguagePt && additionalLanguagePt[0] && additionalLanguagePt[0].length > 0) || (mainLanguage && hasIdiomaAdic)
}

const langEnglishEnabled = () => {
    let additionalLanguageEn = Util.getLocalConfigs('idiomaAdic_en')
    let mainLanguage = Util.getLocalConfigs('mainLanguage')
    mainLanguage = (mainLanguage && mainLanguage[0] && mainLanguage[0].code === 'en') || false
    let hasIdiomaAdic = hasAnyIdiomaAdic()
    return (additionalLanguageEn && additionalLanguageEn[0] && additionalLanguageEn[0].length > 0) || (mainLanguage && hasIdiomaAdic)
}

const langSpanishEnabled = () => {
    let additionalLanguageEs = Util.getLocalConfigs('idiomaAdic_es')
    let mainLanguage = Util.getLocalConfigs('mainLanguage')
    mainLanguage = (mainLanguage && mainLanguage[0] && mainLanguage[0].code === 'es') || false
    let hasIdiomaAdic = hasAnyIdiomaAdic()
    return (additionalLanguageEs && additionalLanguageEs[0] && additionalLanguageEs[0].length > 0) || (mainLanguage && hasIdiomaAdic)
}

const getString = key => {
    const languageOptions = {
        en: en.getString,
        es: es.getString,
        'pt-br': ptbr.getString
    }

    const curLang = languageOptions[currentLanguage]
    return curLang && typeof curLang === 'function' && curLang(key) ? curLang(key) : key
}

const hasAnyIdiomaAdic = () => {
    let additionalLanguageEn = Util.getLocalConfigs('idiomaAdic_en')
    additionalLanguageEn = (additionalLanguageEn && additionalLanguageEn[0]) || ''
    let additionalLanguagePt = Util.getLocalConfigs('idiomaAdic_pt_br')
    additionalLanguagePt = (additionalLanguagePt && additionalLanguagePt[0]) || ''
    let additionalLanguageEs = Util.getLocalConfigs('idiomaAdic_es')
    additionalLanguageEs = (additionalLanguageEs && additionalLanguageEs[0]) || ''

    return additionalLanguageEn || additionalLanguagePt || additionalLanguageEs
}

const getIndexLanguages = function (product, index) {
    let defaultLanguage = 'pt-br'
    let keys = {
        // primeiro nivel de produtos
        groupName: {
            en: 'groupNameEnglish',
            es: 'groupNameEspanish',
            'pt-br': 'groupName'
        },
        productName: {
            en: 'productNameEnglish',
            es: 'productNameEspanish',
            'pt-br': 'productName'
        },
        obsName: {
            en: 'obsNameEnglish',
            es: 'obsNameEspanish',
            'pt-br': 'obsName'
        },
        productGroupName: {
            en: 'groupNameEnglish',
            es: 'groupNameEspanish',
            'pt-br': 'productGroupName'
        },
        subItemName: {
            en: 'subItemNameEnglish',
            es: 'subItemNameEspanish',
            'pt-br': 'subItemName'
        },
        subItemObsGroupName: {
            en: 'subItemObsGroupNameEn',
            es: 'subItemObsGroupNameEs',
            'pt-br': 'subItemObsGroupName'
        },
        subItemObsName: {
            en: 'subItemObsNameEnglish',
            es: 'subItemObsNameEspanish',
            'pt-br': 'subItemObsName'
        },
        subProductGroupName: {
            en: 'subProductGroupNameEnglish',
            es: 'subProductGroupNameEspanish',
            'pt-br': 'subProductGroupName'
        },
        subGroupName: {
            en: 'subGroupNameEnglish',
            es: 'subGroupNameEspanish',
            'pt-br': 'subGroupName'
        },
        productDescription: {
            en: 'productDescriptionEnglish',
            es: 'productDescriptionEspanish',
            'pt-br': 'productDescription'
        },
        obsGroupName: {
            en: 'obsGroupNameEn',
            es: 'obsGroupNameEs',
            'pt-br': 'obsGroupName'
        },
        subItemDescription: {
            en: 'subItemDescriptionEnglish',
            es: 'subItemDescriptionEspanish',
            'pt-br': 'subItemDescription'
        }
    }
    return (product[keys[index][currentLanguage]]) || (product[keys[index][defaultLanguage]])
}

export default {
    getString: getString,
    resetToMainLanguage: resetToMainLanguage,
    setCurrentLanguage: setCurrentLanguage,
    langPortugueseEnabled: langPortugueseEnabled,
    langEnglishEnabled: langEnglishEnabled,
    langSpanishEnabled: langSpanishEnabled,
    getIndexLanguages: getIndexLanguages,
    getCurrentLanguage
}



// WEBPACK FOOTER //
// ./src/assets/controllers/LocaleController.js